import { render, staticRenderFns } from "./table-loader.vue?vue&type=template&id=b192452c"
import script from "./table-loader.vue?vue&type=script&lang=js"
export * from "./table-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports